import React, { Component } from "react";
import { connect } from "react-redux";

import { getWelcome } from "../../actions";
import Loading from "../loading";
import Layout from "../layout";

import IconImg from "../../image/Vote_Center_Logo.png";

class Welcome extends Component {
  componentDidMount() {
    if (!this.props.welcome) {
      this.props.getWelcome();
    }
  }

  renderWelcomeMessage() {
    const { welcome } = this.props;
    if (!welcome) {
      return <Loading />;
    } else {
      return welcome.map((line, i) => {
        return (
          <div key={i}>
            {line}
            <br />
            <br />
          </div>
        );
      });
    }
  }

  renderLogin() {
    return (
      <div style={divStyle}>
        <div>
          <img src={IconImg} alt="VC Logo" style={imageStyle}></img>
        </div>
        <div style={linkStyle}>
         {/* Training information will be available soon. */}
         <a href="https://urldefense.com/v3/__https:/aimorange.precinctcentral.com/TED/ElectionForcePortal/Launchpad.aspx__;!!KL1yqyOaGX2drUI!0PXf_bYJguUUv_TfU9yq5ioJnTZzdAo3MAlbhP-iQLUgABdg2xSBaOb5XMchRkez9xAX$">Click here to access your training information and Vote Center assignment.</a>
		
        </div>
      </div>
      );
    }

  render() {
    return (
      <Layout title="Welcome">
        <div>{this.renderWelcomeMessage()}</div>
        <div>{this.renderLogin()}</div>
      </Layout>
    );
  }
}

const imageStyle = {
  width: '50%',
  height: 'auto',
  border: 'none',
  padding: 12,
  margin: 8
}

const divStyle = {
  textAlign: 'center',
  fontSize: 24
}

const linkStyle = {
  padding: 10
}

const mapStateToProps = (state) => {
  return { welcome: state.empData.welcome };
};

export default connect(mapStateToProps, { getWelcome })(Welcome);
